import styled, { css } from "styled-components";
import media from "helpers/media";

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  display: none;

  ${media.MD`
    display: flex;
  `}
`;

export const Button = styled.button<{ isExpanded: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1.6rem;
  background-color: transparent;
  cursor: pointer;
  border: none;
  outline: none;
  appearance: none;
  min-width: 25rem;
  height: auto;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
  }

  ${media.MD`
    min-width: auto;
    
    padding: 0.6rem 1.2rem;
  `}
`;

export const ButtonText = styled.span`
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.5;
  letter-spacing: 0.0125em;
  color: ${({ theme }) => theme.colors.denim};
  text-align: center;
  white-space: nowrap;

  ${media.MD`
    font-size: 1.4rem;
  `}
`;

export const ChevronWrapper = styled.div<{ isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  transition: transform 0.3s ease;

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      transform: rotate(180deg);
    `}

  svg {
    width: 1.6rem;
    height: 1.6rem;

    path {
      stroke: ${({ theme }) => theme.colors.denim};
      stroke-width: 1.5px;
    }
  }

  ${media.MD`
    width: 1.4rem;
    height: 1.4rem;

    svg {
      width: 1.4rem;
      height: 1.4rem;
    }
  `}
`;

// Optional gradient overlay container for specific use cases
export const GradientContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const GradientOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 8rem;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 27%,
    rgba(255, 255, 255, 0.49) 64%,
    rgba(255, 255, 255, 0) 100%
  );
  pointer-events: none;
  z-index: 1;
`;

export const ShowMoreContainer = styled.div`
  position: relative;
  z-index: 2;
  padding-top: 2rem;
`;
